// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/KioskInactivityWarning/style.css
// module id = 2049
// module chunks = 0